module.exports = __webpack_public_path__ + "static/media/files icon-zip.ed65f166.png";